module.exports = __webpack_public_path__ + "static/media/documentblue.a9114adc.svg";